module.exports = __webpack_public_path__ + "img/Recycling.5ddf747d.png";